(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["msh-buybox-style"] && !Shopify.designMode) return;
  try {
    (function () {
    // Per May's request: "White Sole" should be the default-selected Color
    // on first load, even though "Black Sole" is first in the catalog's own
    // option order (Shopify pre-selects the first option value server-side,
    // which we can't override without reordering values in the Shopify
    // admin — a catalog change, not a theme one). This clicks the real
    // "White Sole" radio once on load to match, same as a customer would.
    // Skipped when the URL already specifies a variant (respects deep
    // links / back-navigation / a merchant sharing a specific-color link).
    //
    // Which value counts as "first" is the merchant-editable
    // `sole_first_value` block setting. This tag compiles to a static asset
    // that never sees Liquid, so the setting arrives via the
    // `--msh-sole-first` custom property the block's style tag writes onto
    // .product-details (same channel already used for --msh-color-label).
    // Reading it here rather than hardcoding keeps the swatch shown FIRST
    // (CSS order, also driven by that setting) and the swatch SELECTED on
    // load from ever drifting apart. Falls back to the previous hardcoded
    // 'white sole' if the property is missing for any reason.
    function mshFirstColorValue(root) {
      var raw = '';
      try {
        raw = window.getComputedStyle(root).getPropertyValue('--msh-sole-first') || '';
      } catch (e) {
        raw = '';
      }
      raw = raw.trim().replace(/^["']/, '').replace(/["']$/, '').trim();
      return (raw || 'white sole').toLowerCase();
    }

    // Returns true only when it actually clicked a radio (triggering
    // Shopify's async variant-change/gallery re-render), false in every
    // "nothing to fix" early-return case. mshRevealGallery below uses this
    // to know whether it's safe to reveal the gallery immediately (no click
    // happened - whatever's on screen is already correct) or whether it
    // must wait for the async re-render + re-filter to land first.
    function initMshDefaultColor(root) {
      var colorInputs = root.querySelectorAll('input[data-option-name="Color" i]');
      if (!colorInputs.length) return false;
      var target = mshFirstColorValue(root);
      var whiteSole = Array.prototype.slice.call(colorInputs).find(function (i) {
        return i.value.toLowerCase() === target;
      });
      if (!whiteSole || whiteSole.checked) return false;
      if (new URLSearchParams(window.location.search).has('variant')) return false;
      if (whiteSole.getAttribute('data-option-available') === 'false') return false;
      whiteSole.click();
      return true;
    }

    // Per May's request: photos should be filtered by Color entirely from
    // the theme side, keyed off each filename's own "-Blk-" / "-WT-" marker
    // (e.g. "...SneakersV2-Blk-STR2-YWV.jpg"), NOT Shopify's native
    // variant-image tagging. Native tagging (hide_variants on the
    // media-gallery block) caps out at ONE photo per Color value — checked
    // directly in Shopify admin (individual photo panel, Media grid
    // multi-select, right-click) and confirmed there's no native path to
    // tag more than one photo per color without a paid app. Filename
    // matching sidesteps that limit completely: every photo already
    // consistently carries its color in the filename, so this needs zero
    // catalog/variant-tagging work — just re-run whenever Color changes.
    // Scoped to the visible grid only (.media-gallery__grid), not the
    // zoom/lightbox dialog's own thumbnail strip — the lightbox reuses the
    // same underlying media list via a different DOM tree we don't touch,
    // so it may still show all photos when opened. That's a known,
    // accepted trade-off, not an oversight.
    function mshColorFromFilename(src) {
      if (/-Blk-STR/i.test(src)) return 'black sole';
      if (/-WT-STR/i.test(src)) return 'white sole';
      return null; // untagged photos always show, regardless of color
    }

    // Photos must display in plain shot-number order (STR1 -> STR8) within
    // each color, matching the reference product May supplied
    // (yeswevibe.com/products/bohemian-life-4, whose 16 photos run
    // Blk-STR1..8 then WT-STR1..8). The catalog's own media order does NOT
    // match that and can't easily be corrected: Shopify admin only exposes
    // drag-and-drop for media reordering, and that could not be automated
    // (native HTML5 drag needs trusted events; simulated drag/pointer
    // sequences all had zero effect). Sorting client-side sidesteps it —
    // the customer-visible order is what matters here. The stored catalog
    // order still drives the collection-page thumbnail and social-share
    // image, so that one photo remains "wrong" until the catalog itself is
    // reordered via the Admin API.
    function mshSortKeyFromFilename(src) {
      var m = /-(Blk|WT)-STR(\d+)-/i.exec(src);
      if (!m) return Number.MAX_SAFE_INTEGER; // untagged photos sort last
      // Black Sole group first, then White Sole — matches the reference.
      var group = m[1].toLowerCase() === 'blk' ? 0 : 1;
      return group * 100 + parseInt(m[2], 10);
    }

    function applyMshPhotoColorFilter(root) {
      var gallery = document.querySelector('.media-gallery__grid');
      if (!gallery) return;
      var checkedColor = root.querySelector('input[data-option-name="Color" i]:checked');
      if (!checkedColor) return;
      // Per May's report (2026-09-02): this filename-based sort/filter was
      // built for products with TWO real Color values (e.g. Black/White
      // Sole), where reordering by the "-Blk-STR#-"/"-WT-STR#-" number in
      // the filename is the only way to keep each color's photos in a
      // consistent sequence (see this function's own long comment further
      // down for that original reasoning). On a product with only ONE
      // Color value, there is nothing to filter between and nothing that
      // needs filename-based reordering — confirmed live that it was
      // silently overriding the merchant's own drag-and-drop photo order in
      // Shopify admin on exactly this kind of single-color product, with no
      // benefit to show for it. Skip entirely so single-color products keep
      // whatever order the merchant set natively.
      var colorInputs = root.querySelectorAll('input[data-option-name="Color" i]');
      if (colorInputs.length < 2) return;
      var selected = checkedColor.value.toLowerCase();

      var containers = Array.prototype.slice.call(
        gallery.querySelectorAll('.product-media-container')
      );
      if (!containers.length) return;

      var sorted = containers.slice().sort(function (a, b) {
        var aImg = a.querySelector('img[src]');
        var bImg = b.querySelector('img[src]');
        return (
          mshSortKeyFromFilename(aImg ? aImg.src : '') -
          mshSortKeyFromFilename(bImg ? bImg.src : '')
        );
      });

      // Only touch the DOM when the order is actually wrong. This matters:
      // reordering is a childList mutation, which the MutationObserver below
      // is watching, so an unconditional re-append would retrigger this
      // function forever. Sorting an already-sorted gallery must be a no-op.
      var needsReorder = sorted.some(function (container, i) {
        return containers[i] !== container;
      });
      if (needsReorder) {
        var frag = document.createDocumentFragment();
        sorted.forEach(function (container) {
          frag.appendChild(container);
        });
        gallery.appendChild(frag);
      }

      var visible = [];
      sorted.forEach(function (container) {
        var img = container.querySelector('img[src]');
        var photoColor = img ? mshColorFromFilename(img.src) : null;
        var show = photoColor === null || photoColor === selected;
        container.hidden = !show;
        container.style.display = show ? '' : 'none';
        container.classList.remove('msh-media--first', 'msh-media--last');
        if (show) visible.push(container);
      });

      // Tag the first/last photo of the visible set so the full-width CSS
      // above can key off something the color filter actually controls.
      if (visible.length) {
        visible[0].classList.add('msh-media--first');
        visible[visible.length - 1].classList.add('msh-media--last');
      }
    }

    // Mobile renders a completely different gallery component than desktop
    // - <slideshow-component> with <slideshow-slide> children and a
    // separate .slideshow-controls__thumbnails strip, not
    // .media-gallery__grid at all (confirmed live: .media-gallery__grid
    // computes display:none at mobile widths, the slideshow is what's
    // actually on screen). applyMshPhotoColorFilter above never touches
    // it, so both colors' photos stayed visible/swipeable on mobile no
    // matter which Color radio was selected. This mirrors the same
    // filename-based filter against that markup instead.
    //
    // Hiding slides via the native `hidden` attribute (rather than some
    // custom class) is deliberate: the theme's own assets/slideshow.js
    // already filters its `slides` getter on `hidden`, and its
    // attributeChangedCallback already knows how to re-select a slide
    // whenever [initial-slide] changes (its own comment there says this
    // exact mechanism is what "Collection page filtering" uses to morph
    // slideshow galleries in place) - so this uses the component's own
    // built-in support instead of fighting it.
    //
    // Also reorders both the slides and their matching thumbnails into the
    // same shot-number sequence the desktop grid already uses
    // (mshSortKeyFromFilename) - confirmed live that the raw catalog order
    // is genuinely scrambled per color (Black Sole ran 2,1,4,5,6,7,8,3;
    // White Sole ran 8,7,6,5,4,3,2,1), so switching colors on mobile jumped
    // between two differently-ordered photo sequences instead of showing
    // the same pose order for both. Slides and thumbnails are two separate
    // DOM trees that only stay paired by matching index, so both must be
    // reordered with the IDENTICAL permutation or the thumbnail-to-slide
    // correspondence would desync.
    //
    // Only forces a slide jump when the slide the customer was actually
    // looking at just got hidden by this filter (a real color change).
    // The MutationObserver below re-runs this on every DOM mutation
    // anywhere on the page (see its own comment for why it has to be that
    // broad), so without this guard an unrelated mutation elsewhere on the
    // page would yank the customer's scroll position back to photo 1
    // mid-browse even when the filter's actual output hasn't changed.
    // Tracked by element reference (not index) across the reorder below,
    // since reordering changes what index the customer's current slide
    // ends up at.
    function applyMshMobileSlideshowFilter(root) {
      var slideshow = document.querySelector('media-gallery slideshow-component');
      if (!slideshow) return;
      var checkedColor = root.querySelector('input[data-option-name="Color" i]:checked');
      if (!checkedColor) return;
      // Same single-color skip as applyMshPhotoColorFilter above (2026-09-02)
      // — see that function's comment for the full reasoning.
      var colorInputs = root.querySelectorAll('input[data-option-name="Color" i]');
      if (colorInputs.length < 2) return;
      var selected = checkedColor.value.toLowerCase();

      var slidesContainer = slideshow.querySelector('slideshow-slides');
      var thumbsContainer = slideshow.querySelector('.slideshow-controls__thumbnails');
      if (!slidesContainer) return;

      // Root cause of the "swipe skips past the adjacent photo" bug
      // (confirmed live 2026-08-07): assets/component.js's Component base
      // class (which Slideshow extends) caches child elements tagged
      // ref="slides[]" into `slideshow.refs.slides` - the array
      // `slideshow.slides`, `slideshow.current`, next()/previous() and the
      // scroll-sync index math (#sync() in assets/slideshow.js) all key off.
      // Component keeps that cache in sync via its OWN MutationObserver, but
      // registers it inside requestIdleCallback (see connectedCallback()) -
      // a deferred, best-effort timing. The very first reorder this function
      // performs (on page load, since Festive Snowflakes' catalog order is
      // already scrambled per color - see mshSortKeyFromFilename's comment)
      // can easily win that race and land BEFORE the observer is attached,
      // so Component never notices the childList mutation and `refs.slides`
      // is left holding the OLD, scrambled order forever after (nothing else
      // ever mutates slideshow-slides' children again once this function's
      // own `needsReorder` check below goes permanently false).
      //
      // Verified directly: after the page-load reorder, slideshow.current
      // was 0 and slideshow.slides[0] resolved to the WRONG photo (the old
      // array's stale index-0), while the ACTUAL on-screen photo (per the
      // real, correctly-sorted DOM/scroll geometry) was a different one -
      // and calling slideshow.next() from that state scrolled to whatever
      // real slide happened to sit at the stale array's "index + 1", which
      // after sorting can be many slides away instead of the visually
      // adjacent one. Every later swipe inherits the same desync.
      //
      // updatedCallback() is not a private workaround: it's the exact PUBLIC
      // hook Component itself exposes for the Section Rendering API's morph
      // to force this same resync after an external subtree change (see its
      // doc comment in component.js) - calling it here uses the component's
      // own sanctioned mechanism instead of reaching into its private state.
      // Called both up front (in case an EARLIER pass already reordered the
      // DOM before the observer attached, leaving refs stale coming into
      // this call) and again right after this pass's own reorder (so
      // slideshow.current/slideshow.slides are correct the instant this
      // function returns, without waiting on the observer's own async
      // microtask, which would otherwise leave a race window open for a
      // real user swipe to land in).
      if (typeof slideshow.updatedCallback === 'function') {
        slideshow.updatedCallback();
      }

      var slides = Array.prototype.slice.call(slidesContainer.children);
      var thumbs = thumbsContainer ? Array.prototype.slice.call(thumbsContainer.children) : [];
      if (!slides.length) return;

      // Compare against the previously-current slide using the SAME index
      // space slideshow.current actually indexes into - slideshow.slides,
      // which excludes hidden slides - not the raw/full children array read
      // above. Those are two different index spaces (16 slides vs. the 8
      // currently visible) any time this filter is active, which is always;
      // indexing the raw array with a filtered-space index would identify
      // the wrong element as "previous" and could force an unwanted extra
      // jump independent of the stale-refs bug above.
      var previousIndex = typeof slideshow.current === 'number' ? slideshow.current : -1;
      var previousFilteredSlides = slideshow.slides || [];
      var previousSlideEl = previousIndex >= 0 ? previousFilteredSlides[previousIndex] : null;

      var order = slides
        .map(function (slide, i) {
          var img = slide.querySelector('img[src]');
          return { i: i, key: mshSortKeyFromFilename(img ? img.src : '') };
        })
        .sort(function (a, b) {
          return a.key - b.key;
        })
        .map(function (entry) {
          return entry.i;
        });

      var needsReorder = order.some(function (originalIndex, newPos) {
        return originalIndex !== newPos;
      });
      if (needsReorder) {
        var slideFrag = document.createDocumentFragment();
        var thumbFrag = document.createDocumentFragment();
        order.forEach(function (originalIndex) {
          slideFrag.appendChild(slides[originalIndex]);
          if (thumbs[originalIndex]) thumbFrag.appendChild(thumbs[originalIndex]);
        });
        slidesContainer.appendChild(slideFrag);
        if (thumbsContainer) thumbsContainer.appendChild(thumbFrag);

        // Resync again immediately after THIS pass's own reorder (see the
        // long comment above at the first updatedCallback() call for why
        // this can't just rely on Component's own MutationObserver timing).
        if (typeof slideshow.updatedCallback === 'function') {
          slideshow.updatedCallback();
        }

        slides = order.map(function (originalIndex) {
          return slides[originalIndex];
        });
        thumbs = order.map(function (originalIndex) {
          return thumbs[originalIndex];
        });
      }

      var previousSlideStillVisible = false;
      var firstVisibleIndex = -1;

      slides.forEach(function (slide, i) {
        var img = slide.querySelector('img[src]');
        var photoColor = img ? mshColorFromFilename(img.src) : null;
        var show = photoColor === null || photoColor === selected;
        slide.hidden = !show;
        if (thumbs[i]) {
          thumbs[i].hidden = !show;
          thumbs[i].style.display = show ? '' : 'none';
        }
        if (show && firstVisibleIndex === -1) firstVisibleIndex = i;
        if (show && slide === previousSlideEl) previousSlideStillVisible = true;
      });

      if (!previousSlideStillVisible && firstVisibleIndex !== -1) {
        slideshow.setAttribute('initial-slide', String(firstVisibleIndex));
      }

      // Tell the counter/dots (assets/slideshow.js) to recompute against
      // only the slides just marked visible above. Needed even when the
      // branch above did NOT fire (previousSlideStillVisible === true): the
      // slideshow's own current-slide setter only recalculates the total
      // when a slide is actually re-selected, so if the customer's current
      // slide survives the color switch, nothing would otherwise tell the
      // counter the total slide count changed (e.g. it would keep showing
      // "1/16" against only 8 now-visible slides). Harmless no-op call in
      // the branch above too - select() will re-run this same recompute a
      // moment later once its queued microtask fires.
      if (typeof slideshow.refreshControls === 'function') {
        slideshow.refreshControls();
      }
    }

    // Shopify re-renders the whole media-gallery section via an async
    // fetch when the variant changes (confirmed live: the .media-gallery__grid
    // DOM node itself gets swapped out for a fresh one, not just updated
    // in place), which wipes out any hidden/display changes applied by a
    // simple 'change' listener before that swap lands. A MutationObserver
    // on a stable ancestor catches the swap whenever it actually finishes
    // and re-applies the filter — watching childList/subtree only (not
    // attributes), so our own hidden/display writes below don't
    // re-trigger this observer and cause a loop.
    // Reveals the gallery hidden by the .msh-gallery-ready CSS rule above.
    // Idempotent (classList.add on an already-present class is a no-op), so
    // it's safe to call this repeatedly / from more than one call site.
    function mshRevealGallery(root) {
      root.classList.add('msh-gallery-ready');
      // .msh-price-ready is the price row's own anti-flash class (split from
      // .msh-gallery-ready 2026-08-11 - see the CSS comment on
      // .msh-price-ready). Adding it here too means every existing call site
      // of this function (mshAwaitPriceReady, initAll, both safety-net
      // timeouts) reveals both rows exactly as before - the price row always
      // needed revealing on every option change, and still does.
      root.classList.add('msh-price-ready');
      // Loading spinner (see the .msh-selecting CSS above) is done the moment
      // the gallery/price row are confirmed settled - same signal, same
      // safety nets (mshAwaitPriceReady's 1200ms poll cap, the 'change'
      // listener's 3000ms backstop, and initAll's 1500ms backstop below all
      // call this function), so it can never get stuck spinning forever.
      root.classList.remove('msh-selecting');
      // Clears the "a Color change is in flight" flag the 'change' listener
      // below sets (see its own comment) - read by the MutationObserver
      // further down to decide whether an unrelated page mutation (price
      // text repainting, sticky bar updating, etc. - none of which touch the
      // gallery) is worth re-running the photo filter over. Resetting here,
      // at the one guaranteed end-of-cycle point for every option change
      // (Color included), keeps this in sync with .msh-selecting's own
      // lifecycle without needing a second, separately-timed reset.
      root.dataset.mshColorPending = 'false';
    }

    // Root cause of the live "compare-at price disappears when Men's
    // Sneakers V2 is selected" bug (confirmed 2026-08-07 via direct fetch
    // to /products/<handle>?option_values=..., not CSS): this product's
    // Style values share ONE "Size" option whose real values are totally
    // disjoint between styles (Women's runs US 5.5-12, Men's runs
    // US 6-15). Native radio inputs never auto-uncheck just because a
    // change to a SIBLING fieldset made them invalid, and neither
    // Shopify's variant-picker.js nor this block ever re-picks a Size
    // after a Style change. So switching Style can leave an
    // impossible combo checked (e.g. Men's + a Women's-only Size), and
    // Shopify's own variant resolution then finds NO matching variant at
    // all for that option_values request - snippets/price.liquid
    // correctly renders a blank price (no sale price, no compare-at
    // price) because there's no selected_variant to read from. Not a
    // hidden-vs-missing-data question: the compare-at-price element does
    // not exist in that server response at all.
    //
    // Fix mirrors the exact pattern initMshDefaultColor already uses for
    // Color on page load: after any option change has finished morphing
    // in, if the checked Size is now marked unavailable, click the first
    // Size that IS available for the current Style/Color. That triggers
    // its own real variant-picker change/fetch (same mechanism, so price
    // and gallery update the normal way) and is idempotent - once a valid
    // Size is checked, this is a no-op, so it can't loop.
    //
    // Return value added 2026-08-07 (mirrors initMshDefaultColor's own
    // true/false return): true only when this actually clicked a corrective
    // Size, meaning a SECOND fetch/morph is now in flight. The
    // MutationObserver below uses this to know it must NOT reveal the
    // gallery/price row yet in that case - confirmed live that revealing
    // immediately here was exactly why the price row's blank "no variant"
    // state (see the CSS anti-flash comment above) was painting on screen:
    // this function's own corrective click was still resolving when the
    // observer's very next line unconditionally revealed everything.
    function mshFixInvalidSize(root) {
      var checkedSize = root.querySelector('input[data-option-name="Size" i]:checked');
      if (!checkedSize) return false;
      if (checkedSize.getAttribute('data-option-available') !== 'false') return false;
      var sizeInputs = root.querySelectorAll('input[data-option-name="Size" i]');
      var firstAvailable = Array.prototype.slice.call(sizeInputs).find(function (input) {
        return input.getAttribute('data-option-available') !== 'false';
      });
      if (!firstAvailable) return false;
      firstAvailable.click();
      return true;
    }

    // Per May's reports (2026-09-03): switching Style makes the page content
    // below the Size grid jump, because Women's and Men's have different
    // Size ranges (see mshFixInvalidSize's comment above) so the grid
    // renders at a different height for each Style. Three approaches were
    // tried and rejected in turn - a FLIP-style animate transition (still
    // visibly resized, and its explicit `el.style.height` fought a later
    // reservation attempt, making the Size buttons themselves flash bigger
    // then shrink back), reserving the taller Style's height (fixed the
    // jump but left a permanent blank gap under the shorter Style's list),
    // and reserving the shorter Style's height with the taller one
    // scrolling inside that same box (no jump, no gap, but May didn't like
    // how the scrollable box looked/behaved for Men's). Final call: drop
    // all of it and let the grid reflow at its natural height per Style,
    // same as this file did originally - the content below just moves,
    // which is the accepted trade-off.

    // RACE CONDITION FIX (2026-08-07). The reveal logic above
    // (mshFixInvalidSize gating mshRevealGallery from inside a generic
    // MutationObserver watching document.body) looked correct but wasn't:
    // live instrumented capture (MutationObserver + performance.now(),
    // logging data-option-available and price text on every single firing)
    // caught that observer firing 6+ times per Style click, spanning
    // ~550-900ms, and the reveal decision was being made on whichever
    // firing happened to come first - which was routinely an EARLY firing
    // triggered by a childList mutation that has nothing to do with this
    // product's buy box at all (a single node appended directly to <body>,
    // confirmed live via outerHTML - most likely an aria-live/announcer
    // element some other script on the page uses), landing 400-800ms BEFORE
    // Shopify's real variant-availability data. A scoped-mutation +
    // debounce version of the same idea was tried next and ALSO failed
    // live: gaps between separate, genuinely relevant mutation batches of
    // the SAME Style-change cascade measured 100ms-700ms across repeated
    // trials (network-dependent), and a price-content check alone
    // (mshPriceLooksReady below, added first as a standalone gate) still
    // let a reveal through once live-tested against back-to-back Style
    // clicks, because a mutation batch can land where the checked Size's
    // data-option-available is still stale AND the price element still
    // holds the OLD (non-empty, so it passed the check) value - the
    // "stale-but-not-blank" case neither a scope filter nor a content
    // check alone can distinguish from "genuinely settled", because both
    // are still just guessing from incidental DOM timing.
    //
    // The actual fix: stop guessing from document.body mutations entirely
    // and hook the SAME signal Shopify's own variant-picker.js already uses
    // internally. Reading assets/variant-picker.js live (fetchUpdatedSection)
    // shows every option change - Style, Color, Size, and this block's own
    // corrective clicks alike - dispatches a standard 'shopify:product:select'
    // event (bubbles, non-composed; @shopify/events' ProductSelectEvent)
    // carrying a `promise` that resolves only once that SPECIFIC fetch's
    // response has been parsed AND its section morph already applied
    // (updateVariantPicker() runs before the promise resolves, confirmed by
    // reading the source) - i.e. the exact "this fetch is fully landed"
    // signal this mechanism was trying to approximate via timing/heuristics
    // all along, now read directly from the source of truth instead of
    // inferred from its side effects.
    //
    // Confirmed live this closes the gap mshFixInvalidSize's stale-read
    // problem came from: because updateVariantPicker() (which morphs in the
    // fresh Size fieldset, availability attributes included) runs before
    // the promise resolves, checking data-option-available inside the
    // .then() callback below is never reading data from before this
    // specific fetch landed, unlike a body-wide MutationObserver firing
    // that could be triggered by anything.
    //
    // One remaining gap, also measured live: the resolved promise's own
    // data can still arrive before the ON-SCREEN price text repaints - a
    // separate component reacts to the same event/promise independently,
    // measured live at up to ~126ms behind the promise resolving. This
    // doesn't assume resolve == fully painted; mshAwaitPriceReady below
    // polls for that specific, narrow, already-measured gap rather than
    // re-introducing a blind timing guess for the whole cascade.
    function mshPriceLooksReady(root) {
      var checkedSize = root.querySelector('input[data-option-name="Size" i]:checked');
      // Unavailable per Shopify's own data - not a timing question, this
      // combo may genuinely have no variant. mshFixInvalidSize (called
      // right before this) already tried to correct it; if a checked Size
      // is STILL marked unavailable at this point, it's not safe yet.
      if (checkedSize && checkedSize.getAttribute('data-option-available') === 'false') {
        return false;
      }
      var priceEl = root.querySelector('.price');
      // No price markup on this product at all - nothing to gate on.
      if (!priceEl) return true;
      return priceEl.textContent.trim().length > 0;
    }

    // Bridges the ~126ms (measured live) gap between the
    // shopify:product:select promise resolving and the price element's own
    // text actually repainting (a different component's reaction to the
    // same event, not synchronous with the morph this block cares about).
    // Bounded well under the 3000ms 'change'-listener safety net below, so
    // a combo that's genuinely never going to have a price (e.g. no
    // available variant at all after mshFixInvalidSize gave up) still gets
    // revealed eventually by that safety net rather than staying hidden
    // forever - this just stops guessing once it's clearly not a short
    // repaint lag anymore.
    function mshAwaitPriceReady(root) {
      var start = performance.now();
      var MAX_WAIT_MS = 1200;
      (function poll() {
        if (mshPriceLooksReady(root)) {
          mshRevealGallery(root);
          return;
        }
        if (performance.now() - start >= MAX_WAIT_MS) return;
        setTimeout(poll, 25);
      })();
    }

    // Registers the actual completion listener (see the long comment
    // above). Scoped to events originating from inside THIS root so a page
    // with more than one product/variant-picker never cross-reacts to a
    // different product's fetch.
    function mshWatchProductSelect(root) {
      document.addEventListener('shopify:product:select', function (event) {
        if (!(event.target instanceof Node) || !root.contains(event.target)) return;
        var promise = event.promise;
        if (!promise || typeof promise.then !== 'function') return;
        // event.detail.changedOptionName is set synchronously by
        // assets/variant-picker.js from the exact input that fired this
        // change (see its own comment) - read here, not guessed, to know
        // whether THIS fetch's result can possibly contain different
        // photos. Per this fix's premise (Style/Size never legitimately
        // change which photos apply on this store - see
        // assets/media-gallery.js's comment and this fix's report for the
        // verification status of that premise), the photo filter is skipped
        // entirely when the change wasn't Color: the gallery DOM is
        // otherwise completely untouched by this fetch too
        // (assets/media-gallery.js skips its replace for the same reason),
        // and re-running the filter against the SAME unchanged gallery would
        // just be redundant hidden/display/order writes with zero visible
        // effect - exactly the "re-filtered" flicker risk this fix removes.
        var changedOptionName = (event.detail && event.detail.changedOptionName) || '';
        var colorChanged = changedOptionName.toLowerCase() === 'color';
        promise
          .then(function () {
            if (colorChanged) {
              applyMshPhotoColorFilter(root);
              applyMshMobileSlideshowFilter(root);
            }
            // Found live while testing the Size-grid height fix above: any
            // option change morphs the whole variant-picker markup back in
            // from the server's plain, unenhanced HTML - including the
            // single-value Color/Sole row mshAddSingleColorSwatch rebuilt
            // into "COLOR: Black Sole" + a round swatch. initAll() below
            // only ever called it once, on first page load, so the round
            // swatch silently reverted to plain "Color Black Sole" text on
            // every single Style click (confirmed live). The function
            // guards on a data-mshSwatchAdded flag per row, so re-running it
            // here on every settle is a safe no-op for rows already done and
            // correctly re-enhances a freshly morphed-in row.
            mshAddSingleColorSwatch(root);
            // If this fetch left the checked Size invalid, mshFixInvalidSize
            // fires its own corrective click here, which dispatches its own
            // fresh shopify:product:select event - this same listener picks
            // that one up too, so nothing further is needed in this branch.
            if (mshFixInvalidSize(root)) return;
            mshAwaitPriceReady(root);
          })
          .catch(function () {
            // Aborted (superseded by a newer selection) or failed fetch -
            // either a fresh event is already in flight for the newer
            // selection, or the safety-net timeout elsewhere recovers.
          });
      });
    }

    function initMshPhotoColorFilter(root) {
      applyMshPhotoColorFilter(root);
      applyMshMobileSlideshowFilter(root);
      root.querySelectorAll('input[data-option-name="Color" i]').forEach(function (input) {
        input.addEventListener('change', function () {
          applyMshPhotoColorFilter(root);
          applyMshMobileSlideshowFilter(root);
        });
      });

      // Root cause of the flicker reported on Style/Color/Size taps alike
      // (confirmed live): assets/media-gallery.js's #handleProductSelect
      // does a native `this.replaceWith(newMediaGallery)` on ANY variant
      // change - all three option types dispatch the same
      // ProductSelectEvent, and it is a full node replacement, not a
      // Shopify morph. The fresh node arrives straight from the server in
      // its default, UNFILTERED state (all 16 photos, catalog order) and
      // paints immediately; only once the MutationObserver below notices
      // the replacement does it re-apply the color filter/reorder. That gap
      // is the flicker - it is NOT the .msh-gallery-ready anti-flash rule
      // misfiring, it's the opposite: confirmed live that .msh-gallery-ready
      // never gets removed once added on first load, so this hide rule
      // only ever protected that one first paint. Every later variant
      // click showed the unfiltered gap completely unguarded, for Style
      // and Size too (neither actually changes which photos apply, but
      // both still replace the gallery node, wiping out the filter's work
      // just the same).
      //
      // Re-engaging the SAME hide on every change (not attached per-input,
      // since Style/Size inputs can themselves be added/removed by a later
      // morph - e.g. newly-unavailable sizes for a different Style - root
      // itself is never replaced, confirmed live, unlike media-gallery) is
      // the smallest fix: hide again the instant ANY option changes, then
      // let the existing MutationObserver's re-filter + mshRevealGallery
      // call below reveal it again once the replacement has actually
      // landed and been corrected.
      //
      // UPDATE 2026-08-11: superseded for Style/Size specifically. Per
      // May's request the gallery should now stay completely inert (not
      // even a hide/reveal blip) for Style/Size, since media-gallery.js no
      // longer replaces the gallery node for them at all - there is nothing
      // left to hide/reveal around. The paragraph above still describes why
      // the hide-on-every-change approach was needed in the first place and
      // still applies as-is to real Color changes; see the isColorChange
      // branch immediately below for the narrowed behavior.
      root.addEventListener('change', function (event) {
        if (!(event.target instanceof Element)) return;
        if (!event.target.matches('input[data-option-name]')) return;
        var changedName = (event.target.getAttribute('data-option-name') || '').toLowerCase();
        var isColorChange = changedName === 'color';
        // Gallery anti-flash (the .msh-gallery-ready visibility toggle) now
        // only engages for an actual Color change. Style/Size clicks no
        // longer touch the gallery DOM at all (assets/media-gallery.js skips
        // its replace, and mshWatchProductSelect's promise handler above
        // skips the photo filter) - removing this class unconditionally, as
        // before, would itself BE a visible flash (a bare hide with no
        // replacement ever landing to justify revealing again), which is
        // exactly what this fix is removing.
        if (isColorChange) {
          root.classList.remove('msh-gallery-ready');
        }
        // Tracks "a Color-change fetch is currently in flight" for the
        // MutationObserver below, which has no per-event context of its own
        // (it fires for ANY document.body mutation, not just this one).
        // Overwritten - not accumulated - on every change: an abort-superseded
        // earlier Color change never actually finishes (variant-picker.js
        // aborts the previous fetch), so only the LATEST change's outcome
        // matters, same concurrency model the rest of this file already
        // assumes. Reset back to 'false' by mshRevealGallery once this
        // cycle's fetch actually settles.
        root.dataset.mshColorPending = isColorChange ? 'true' : 'false';
        // Price row anti-flash still applies to every option change, exactly
        // as before (Style can invalidate the checked Size and blank the
        // price mid-fetch - see mshFixInvalidSize/its long comment above) -
        // now keyed on its own .msh-price-ready class (see the CSS comment).
        root.classList.remove('msh-price-ready');
        // Start the loading spinner (see .msh-selecting CSS above) the instant
        // any option changes - mirrors the anti-flicker hide immediately above,
        // reusing the exact same event and the exact same reveal/backstop paths
        // to clear it, so it can't drift out of sync with the hide/reveal state.
        root.classList.add('msh-selecting');
        // Safety net: never leave the gallery/price row hidden forever if
        // the MutationObserver below somehow never fires for this change
        // (e.g. an aborted/failed fetch) - mirrors the identical safety net
        // in initAll below. Raised from 1500ms to 3000ms on 2026-08-07: a
        // Style change that also has to correct an invalid Size (see
        // mshFixInvalidSize) is TWO fetches back to back, not one - measured
        // live at up to ~1.9s end to end, which the old 1500ms safety net
        // could fire in the middle of, revealing the still-blank price row
        // early and producing the exact flash this fix closes. 3000ms keeps
        // a comfortable margin over that measured worst case while still
        // only ever engaging as a true failure backstop.
        setTimeout(function () {
          mshRevealGallery(root);
        }, 3000);
      });

      // Observing document.body (not the gallery's own parent) on purpose:
      // confirmed live that Shopify's re-render replaces an ancestor higher
      // up than just the grid's immediate parent, which would silently
      // detach an observer targeting that parent — body is guaranteed to
      // never itself be swapped, so it reliably sees the replacement land
      // no matter how far up the tree Shopify's section update reaches.
      //
      // Kept ONLY for re-applying the photo color filter/reorder now
      // (2026-08-07) - the reveal decision that used to live in this same
      // callback moved to mshWatchProductSelect/mshAwaitPriceReady above,
      // hooked to Shopify's own 'shopify:product:select' completion signal
      // instead of guessed from whichever body mutation happens to fire
      // first (see that long comment for why the guess-based version kept
      // revealing too early). This observer still matters on its own: the
      // media gallery gets replaced wholesale (see the flicker root-cause
      // comment below) and that replacement isn't reliably tied to the
      // SAME promise the buy box side hooks, so this stays as the trigger
      // for re-filtering photos whenever that swap lands. Calling
      // applyMshPhotoColorFilter/applyMshMobileSlideshowFilter here is
      // always safe even when unrelated - both are no-ops if nothing
      // actually needs reordering/hiding.
      var observer = new MutationObserver(function () {
        // Gated on the SAME "Color change in flight" flag the 'change'
        // listener above sets/mshRevealGallery clears (2026-08-11). Without
        // this, a Style/Size click's OTHER page updates (price text
        // repainting, sticky bar, the variant-picker fieldset itself
        // morphing) still trigger childList mutations somewhere on
        // document.body, which used to re-run the photo filter against the
        // gallery every time - redundant hidden/display/order writes with
        // zero visual effect, but writes all the same, which is exactly the
        // "gallery must not be touched/re-filtered at all" requirement this
        // fix closes. Still fires freely for real Color changes, unchanged
        // from before.
        if (root.dataset.mshColorPending !== 'true') return;
        applyMshPhotoColorFilter(root);
        applyMshMobileSlideshowFilter(root);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    // Per May's report (2026-09-02): switching Style changes how many Size
    // buttons are available (e.g. Men's runs US 3-15, 23 values; Women's
    // runs US 4.5-12, 16 values — see mshFixInvalidSize's comment above for
    // the same disjoint-ranges premise), so the two-column Size grid
    // renders at a different height for each Style, and content below it
    // shifts. Two attempts at reserving fixed space for the grid (measuring
    // the combined 39-value list, then the larger single-style list) both
    // left a visible blank gap under the shorter list instead. Checked
    // yeswevibe.com's own Bohemian Wolf product page (same Style/Size
    // button-grid pattern this block was modeled on) at May's request —
    // confirmed live it reserves no space at all and simply lets the grid
    // reflow naturally on every Style click, same as this file did before
    // any of this was added. Matching that reference instead of continuing
    // to fight it here.

    // Per May's request (2026-09-02): products with only ONE Color value
    // (e.g. this store's "Black Sole" single-value case) get a round swatch
    // matching yeswevibe.com's reference, instead of plain "Color Black
    // Sole" text with nothing else. Root cause: snippets/variant-main-
    // picker.liquid renders a single-value option as
    // `<div data-testid="variant-option-single">Color<span
    // class="variant-option__swatch-value">Black Sole</span></div>` with NO
    // `<input>` at all (confirmed live — zero
    // `input[data-option-name="Color" i]` elements exist on this exact
    // product) — every other swatch rule in this file keys off
    // `:has(input...)` and has nothing to attach to here. This inserts one
    // small span carrying the same black/white swatch classes directly into
    // that plain-text row instead.
    //
    // Only touches a row whose OWN option name matches the configured Color/
    // Sole option (--msh-sole-option-name, same channel as --msh-sole-first)
    // — a product with some other single-value option (e.g. a one-size-only
    // "Size") must never get a swatch dot injected into it.
    function mshSoleOptionName(root) {
      var raw = '';
      try {
        raw = window.getComputedStyle(root).getPropertyValue('--msh-sole-option-name') || '';
      } catch (e) {
        raw = '';
      }
      raw = raw.trim().replace(/^["']/, '').replace(/["']$/, '').trim();
      return (raw || 'color').toLowerCase();
    }

    function mshAddSingleColorSwatch(root) {
      var targetOptionName = mshSoleOptionName(root);
      var rows = root.querySelectorAll('.variant-option[data-testid="variant-option-single"]');
      rows.forEach(function (row) {
        if (row.dataset.mshSwatchAdded === 'true') return;
        var valueEl = row.querySelector('.variant-option__swatch-value');
        if (!valueEl) return;
        var value = (valueEl.textContent || '').trim();
        var optionName = (row.textContent || '').replace(value, '').trim();
        if (optionName.toLowerCase() !== targetOptionName) return;
        row.dataset.mshSwatchAdded = 'true';
        row.classList.add('msh-single-swatch-row');

        // Per May's report (2026-09-02): rebuild as two stacked lines,
        // matching yeswevibe.com's reference exactly — "COLOR: Black Sole"
        // (option name upper-cased, one line, with a colon) then the round
        // swatch on its own line below. The native markup instead put
        // "Color" and "Black Sole" as two separate text nodes with no
        // colon, which under flex-direction: column (needed to put the
        // swatch on its own row) rendered as three separate stacked lines
        // instead of the intended two. Clearing and rebuilding the row's
        // contents from scratch is simpler and more robust than trying to
        // reflow the original text nodes in place.
        var labelLine = document.createElement('div');
        labelLine.className = 'msh-single-swatch-label';
        labelLine.textContent = optionName.toUpperCase() + ': ' + value;

        var swatch = document.createElement('span');
        swatch.className = 'msh-single-swatch';
        if (/black/i.test(value)) {
          swatch.classList.add('msh-single-swatch--black');
        } else if (/white/i.test(value)) {
          swatch.classList.add('msh-single-swatch--white');
        }

        row.textContent = '';
        row.appendChild(labelLine);
        row.appendChild(swatch);
      });
    }

    // Per May's report (2026-09-02): even after removing the artificial
    // price-hiding CSS, switching Style still visibly "freezes" for a
    // couple of seconds before the price reappears. Root cause, confirmed
    // by re-reading the flow rather than guessing: switching Style when the
    // currently-checked Size doesn't exist for the new Style (very common —
    // Men's and Women's Size ranges never overlap, confirmed live 16 + 23 =
    // 39 with zero shared values) triggers TWO sequential real network
    // round-trips — one for the Style change itself, then a second,
    // separate one from mshFixInvalidSize's own corrective click once the
    // first fetch reveals the Size is now invalid. Removing the CSS hide
    // only stopped a self-inflicted extra wait on TOP of that; it can't
    // remove the two real round-trips themselves, which is what actually
    // reads as "frozen" on a slower connection.
    //
    // Fix: correct the Size BEFORE the Style click's own fetch fires, not
    // after. Since the two Style values' Sizes never overlap, whichever
    // Size is currently marked data-option-available="false" is guaranteed
    // to belong to the style about to be selected — pre-checking it (via a
    // capture-phase click listener, so this runs before variant-picker.js's
    // own change handler starts its fetch) means that ONE fetch already
    // reflects the correct final Style+Size combo. No second round-trip,
    // no window where the price has no matching variant to read from.
    // Setting `.checked = true` directly (not `.click()`) deliberately does
    // NOT dispatch its own change/input event, so this never fires a
    // separate fetch of its own — it only changes what the Style click's
    // already-about-to-happen fetch reads.
    //
    // UPDATE (2026-09-03, per May's report that the first Size still takes
    // "milliseconds" to color in after Style is clicked): the original
    // version above only ever set `.checked` on the replacement Size input,
    // never touching `data-option-available`. That looked instant on paper
    // (native `:checked` is synchronous), but the newly-checked Size input
    // was still sitting inside a button STILL MARKED data-option-available
    // ="false" from the old Style - and .product-details .variant-option__
    // button-label:has(input[data-option-available="false"]) { display:
    // none } (elsewhere in this file) was still hiding it. So the old Size
    // button lost its highlight instantly (native radio-group exclusivity),
    // but the new one didn't visibly gain one until the real fetch's morph
    // caught up and flipped the attribute - a real gap, not a perception
    // issue. Confirmed live: ALL 39 Size inputs for this product already
    // exist in the DOM at all times (both Styles' full ranges), 16 marked
    // true / 23 false for Women's, so there's no need to wait on the server
    // to know which ones swap - flipping every input's own
    // data-option-available here (true <-> false) client-side reproduces
    // exactly what the fetch response is about to confirm anyway, so the
    // Size grid shows/hides the right buttons AND highlights the first
    // available one in the same click, with zero network dependency. The
    // eventual real morph still lands moments later and simply reconfirms
    // the same state (or corrects it, on a store where this 2-value/
    // non-overlapping-ranges assumption doesn't hold) - never a source of
    // permanently-wrong data, just a visual head start.
    // NO height animation on the Size grid - deliberately, after trying one
    // twice (2026-09-04). Context, so nobody re-adds it:
    //
    // Women's renders 16 Sizes (411px on mobile) and Men's 23 (605px), so
    // switching Style genuinely changes the grid's height by ~194px / 4 rows
    // and SOMETHING has to move. Reserving the taller height leaves that
    // much dead space under Women's (rejected by May), a fixed height with
    // the taller list scrolling inside it (also rejected), and a 3-column
    // grid is worse still - measured live, the labels wrap to two lines and
    // the grid gets TALLER (440px), not shorter.
    //
    // A 260ms glide was then tried to soften the remaining movement, and it
    // caused three separate bugs of its own: it fought a leftover min-height
    // reservation; it left `overflow: hidden` stuck on the grid (clipping
    // the buttons' focus outlines); and worst, a paused/throttled animation
    // stayed frozen on its first keyframe, PINNING the grid at the old
    // height with the size list clipped, then snapping open when it finally
    // resolved - measured live at a flat 414px while 23 Men's sizes were
    // present. Each fix exposed the next failure, and May still reported
    // jumping after rapid Style switching.
    //
    // Plain instant reflow has none of those failure modes and already
    // satisfies the actual requirement, confirmed by measurement: on a Style
    // switch the price, Style, Color and the Size grid's own top edge all
    // stay exactly put (grid top 333px before and after, scroll position
    // unchanged), and ONLY the sections below it (Core Features ->
    // Why You'll Love) move, by the 195px the grid genuinely changed by.
    // The movement is inherent to the two lists differing by 4 rows; it is
    // not a bug, and animating it only added ways for the grid to get stuck
    // at a wrong height.

    function mshPreCorrectSizeOnStyleChange(root) {
      var styleFieldset = root.querySelector('fieldset:has(input[data-option-name="Style" i])');
      if (!styleFieldset) return;
      var initiallyChecked = styleFieldset.querySelector('input[data-option-name="Style" i]:checked');
      var lastStyleValue = initiallyChecked ? initiallyChecked.value : null;
      styleFieldset.addEventListener(
        'click',
        function (event) {
          var target = event.target;
          if (!(target instanceof HTMLInputElement)) return;
          if ((target.getAttribute('data-option-name') || '').toLowerCase() !== 'style') return;
          // A re-click of the value that's already active (native radios
          // still dispatch 'click' for that) - nothing actually changed, so
          // flipping every Size input's availability here would incorrectly
          // invert an already-correct state instead of leaving it alone.
          if (target.value === lastStyleValue) return;
          lastStyleValue = target.value;

          // A diagonal "sold out ribbon" artifact that used to flash across
          // multiple Size buttons here (per May's report, 2026-09-04) turned
          // out to come from a completely different mechanism - see the
          // comment on .variant-option__strikethrough's display: none above
          // for the root cause, which was not anything about this loop.
          //
          // Applied directly, with no height animation wrapped around it -
          // see the long "NO height animation" comment above this function
          // for why one was tried twice and deliberately removed.
          var sizeInputs = root.querySelectorAll('input[data-option-name="Size" i]');
          var firstNewlyAvailable = null;
          sizeInputs.forEach(function (input) {
            var wasAvailable = input.getAttribute('data-option-available') === 'true';
            var nowAvailable = !wasAvailable;
            input.setAttribute('data-option-available', nowAvailable ? 'true' : 'false');
            if (nowAvailable && !firstNewlyAvailable) {
              firstNewlyAvailable = input;
            }
          });
          if (firstNewlyAvailable) {
            firstNewlyAvailable.checked = true;
          }
        },
        true
      );
    }

    function initAll() {
      document.querySelectorAll('.product-details').forEach(function (root) {
        mshAddSingleColorSwatch(root);
        mshPreCorrectSizeOnStyleChange(root);
        // Attach the completion listener (mshWatchProductSelect) and the
        // photo-filter observer BEFORE initMshDefaultColor can possibly
        // click anything - fetchUpdatedSection dispatches
        // 'shopify:product:select' synchronously, before its own fetch
        // even starts, so attaching this listener any later would miss the
        // very first dispatch when a default-color correction is needed on
        // load.
        initMshPhotoColorFilter(root);
        mshWatchProductSelect(root);
        // True only when initMshDefaultColor actually had to click a radio
        // to fix the default color - every other case (no Color option,
        // already correct, ?variant= deep link, target unavailable) means
        // whatever's already on screen is correct, so it's safe to reveal
        // immediately with no wait at all.
        var neededFix = initMshDefaultColor(root);
        if (!neededFix) {
          mshRevealGallery(root);
        } else {
          // Safety net: reveal no matter what after 1.5s even if the
          // shopify:product:select promise never resolves/fires for some
          // reason, so a failure here degrades to "briefly hidden gallery"
          // at worst, never "gallery hidden forever".
          setTimeout(function () {
            mshRevealGallery(root);
          }, 1500);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["msh-filter-group"] && !Shopify.designMode) return;
  try {
    (function () {
    // Fully generic: carries no threshold/count/block-id knowledge at
    // all (that all lives in the CSS above, per group instance). Every
    // group's button is wired the same way, so this script's text is
    // identical across every block instance and Shopify can dedupe it
    // into a single copy in the compiled bundle, same as the pattern
    // already used in blocks/msh-product-accordion.liquid.
    function initMshFilterShowMore(button) {
      if (button.dataset.mshShowMoreBound === 'true') return;
      button.dataset.mshShowMoreBound = 'true';

      button.addEventListener('click', function () {
        var group = button.closest('.filter-group');
        if (!group) return;

        var expanded = group.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        button.textContent = expanded ? 'Show less' : 'Show more';
      });
    }

    function initAll() {
      document.querySelectorAll('[data-msh-filter-showmore]').forEach(initMshFilterShowMore);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    // Re-wire after a section re-render swaps in fresh markup (theme
    // editor saves, morph sections). The dataset guard above leaves any
    // surviving, already-bound button alone.
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["msh-product-accordion"] && !Shopify.designMode) return;
  try {
    (function () {
    function initMshAccJump(root) {
      // Guard: this block now lives inside the product-information section,
      // which Shopify re-renders (morphs) on every variant change, so initAll
      // can legitimately run again over a list that is already wired up.
      // Binding twice would fire two scroll calls per click.
      if (root.dataset.mshAccJumpBound === 'true') return;
      root.dataset.mshAccJumpBound = 'true';

      var jumpItems = root.querySelectorAll('[data-msh-acc-jump-target]');
      jumpItems.forEach(function (details) {
        var summary = details.querySelector(':scope > summary');
        if (!summary) return;
        summary.addEventListener('click', function (e) {
          var targetId = details.getAttribute('data-msh-acc-jump-target');
          var target = targetId ? document.getElementById(targetId) : null;
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    function initAll() {
      document.querySelectorAll('.msh-acc-list').forEach(initMshAccJump);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    // Re-wire after a section re-render swaps in a fresh copy of this markup
    // (the replacement DOM node has no dataset flag, so the guard above lets
    // it through while leaving any surviving instance alone).
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["msh-reviews-link"] && !Shopify.designMode) return;
  try {
    (function () {
    function initMshReviewsLink(btn) {
      btn.addEventListener('click', function () {
        var targetId = btn.getAttribute('data-msh-reviews-target') || 'msh-product-reviews';
        var target = document.getElementById(targetId);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    function initAll() {
      document.querySelectorAll('[data-msh-reviews-link]').forEach(initMshReviewsLink);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["msh-size-guide"] && !Shopify.designMode) return;
  try {
    /* EVENT DELEGATION, not per-instance binding (rewritten 2026-09-11).

     Previously this script ran once on DOMContentLoaded, walked
     document.querySelectorAll('.msh-size-guide') and attached click
     listeners to each instance's trigger/tabs/close/overlay.

     That is fatal for the quick-add modal. assets/quick-add.js builds the
     modal by fetching the real product page, running
     `gridElement.cloneNode(true)` on its [data-product-grid-content]
     subtree, caching that, and morphing a further clone into
     #quick-add-modal-content. cloneNode copies ELEMENTS but never event
     listeners, and this script has already run and will never run again -
     so the size guide inside the modal was inert markup: tapping the
     trigger did nothing and the Men/Women tabs did nothing.

     (Shopify's own components survive the same cloning because they are
     custom elements - connectedCallback re-fires the moment a clone is
     inserted. A plain theme-block javascript tag has no such hook.)

     Delegation fixes it at the root: one listener on `document`, which
     exists before any clone and outlives all of them, resolving the
     instance from the click target at click time. Every instance - the one
     rendered server-side on the product page, and any number of clones
     injected into the quick-add modal later - works with zero
     initialisation, so nothing can be "missed". No init pass, no
     MutationObserver, no re-binding on modal open.

     State lives entirely in the DOM (the .is-open / .is-active classes),
     so there is nothing per-instance left to keep in sync. */
  (function () {
    var SELECTORS = '[data-msh-sg-trigger], [data-msh-sg-close], [data-msh-sg-overlay], [data-msh-sg-tabs] .msh-size-guide__tab';

    function showChart(root, chart) {
      root.querySelectorAll('[data-msh-sg-tabs] .msh-size-guide__tab').forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-chart') === chart);
      });
      root.querySelectorAll('[data-msh-sg-chart]').forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-msh-sg-chart') === chart);
      });
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var hit = target.closest(SELECTORS);
      if (!hit) return;

      /* Scope every lookup to the clicked instance's own .msh-size-guide
         root, so a page (or a modal) holding more than one size guide can
         never drive the wrong one - same per-instance guarantee the old
         code got from closing over its own root. */
      var root = hit.closest('.msh-size-guide');
      if (!root) return;

      var modal = root.querySelector('[data-msh-sg-modal]');
      if (!modal) return;

      if (hit.hasAttribute('data-msh-sg-trigger')) {
        /* The trigger can sit inside the quick-add modal's <form>; without
           this a tap would submit the add-to-cart form instead of opening
           the chart. (The button is type="button" already, so this is
           belt and braces, but the delegated handler is also the only
           place that still sees the event on its way up.) */
        event.preventDefault();
        modal.classList.add('is-open');
        return;
      }

      if (hit.hasAttribute('data-msh-sg-close') || hit.hasAttribute('data-msh-sg-overlay')) {
        modal.classList.remove('is-open');
        return;
      }

      if (hit.classList.contains('msh-size-guide__tab')) {
        event.preventDefault();
        showChart(root, hit.getAttribute('data-chart'));
      }
    });

    /* Escape closes whichever guides are currently open, wherever they
       live. Kept document-level for the same reason as the click handler. */
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.msh-size-guide__modal.is-open').forEach(function (modal) {
        modal.classList.remove('is-open');
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
